import { EffectCallback, useEffect } from 'react';

export const useMountEffect = (func: EffectCallback) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(func, []);
};
